






































/* General */
import Vue from 'vue'
import moment from 'moment'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export interface IDot {
  id: number
  description: string
  date: Date
  color: string
}

export default Vue.extend({
  name: 'CalendarDatePicker',

  props: {
    dots: {
      type: Array as () => IDot[],
      default: (): IDot[] => [],
    },
    value: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      selectedDay: null,
      page: null,
      themeStyles: {
        wrapper: {
          color: '#3f5b60', // slate
          borderRadius: '8px',
          border: 'solid 1px rgba(96, 76, 63, 0.16)',
          backgroundColor: '#fff',
        },
        header: {
          borderRadius: '8px 8px 0 0',
          backgroundColor: '#01363d',
          padding: `12px`,
          height: `44px`,
        },
        headerTitle: {
          color: '#fff',
          fontSize: '16px',
          fontWeight: '500',
        },
        weekdays: {
          color: '#01363d', // dark-teal
          fontWeight: '500',
          padding: `16px 14px 3px 14px`,
          fontSize: `14px`,
        },
        weeks: {
          padding: `8px`,
        },
        dayCellNotInMonth: {
          color: '#acbcbf',
        },
        dots: {
          marginBottom: '4px',
        },
      },
    }
  },

  computed: {
    attributes(): any {
      return this.dots.map(t => ({
        key: `task.${t.id}`,
        dot: {
          backgroundColor: t.color,
        },
        dates: t.date,
        customData: t,
      }))
    },
  },

  created() {
    this.selectedDay = {
      id: moment(this.value).format('M.D'),
    }
    this.page = {
      month: moment(this.value).month() + 1,
      year: moment(this.value).year(),
    }
  },

  methods: {
    dayClicked(day: any) {
      this.selectedDay = day
      if (!day.inMonth) {
        this.page = {
          month: day.month,
          year: day.year,
        }
      }
      this.$emit('input', day.date)
    },
    getPage(page: any) {
      this.$emit('month-changed', page.year, page.month)
    },
  },
})
